import React, { useState } from 'react';

import { CurrentPlanSelection } from '../../utils/backend-api/subscribe';
import PaymentForm from './PaymentForm';
import SignupForm from './SignupForm';

export interface SubscriptionFormProps {
  buttonText: string;
  currentPlan: CurrentPlanSelection;
  currentTrialEndDate: string;
  prefilledUserName?: string;
  prefilledUserEmail?: string;
  referringSubscriberGuid?: string;
  referringSubscriberName?: string;
  stripeCustomerId?: string;
}

const SubscriptionForm = (props: SubscriptionFormProps) => {
  const [stripeCustomerId, setStripeCustomerId] = useState(props.stripeCustomerId);

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <SignupForm {...props} setStripeCustomerId={setStripeCustomerId} />
          {stripeCustomerId && <PaymentForm {...props} stripeCustomerId={stripeCustomerId} />}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionForm;
